/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Sub_Addons_Storage_Schedule_RemovalInputs */



/**
* | output |
* | --- |
* | "Your storage add-on will be removed on {date}. Select your current tier to cancel." |
*
* @param {Sub_Addons_Storage_Schedule_RemovalInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_addons_storage_schedule_removal = /** @type {((inputs: Sub_Addons_Storage_Schedule_RemovalInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Addons_Storage_Schedule_RemovalInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Ihr Speicher-Zusatzpaket wird am ${i?.date} entfernt. Wählen Sie Ihre aktuelle Stufe, um abzubrechen.`)
	return /** @type {LocalizedString} */ (`Your storage add-on will be removed on ${i?.date}. Select your current tier to cancel.`)
});